import React from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import EmptyList from 'src/components/templates/EmptyList.template';
import AppAssets from 'src/constants/appAssets';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import QuestionList from 'src/modules/exam-preparation/containers/QuestionList';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import useData from './useData';
const BookmarksTab = ({ subjectID, onQuestionPress, getQuestionTo, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData(subjectID);
    return (React.createElement(Column, { style: [styleUtils.ovfHidden, styleUtils.flex] },
        React.createElement(QuestionList, { variant: 'question-paper', ListEmptyComponent: React.createElement(EmptyList, { message: translate('All your\nBookmarked questions\nwill appear here.'), imgSrc: AppAssets.bookmarksEmptyList }), queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVars, onQuestionPress: onQuestionPress, getQuestionTo: getQuestionTo, showsVerticalScrollIndicator: false })));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default BookmarksTab;
